import { useEffect, useRef, useState } from "react";
import { warningMessage } from "../../../utils/toastify-message/ToastifyMessage";

import { findListStart, scheduleContentScroll } from "../../../utils/scroll/pageScroll";

const Pagination = ({ filterDataHandler, pagination }) => {
  const [page, setPage] = useState("");
  const containerRef = useRef(null);

  const changePage = (nextPage) => {
    if (!Number.isInteger(nextPage) || nextPage < 1 || nextPage > pagination?.totalPages || nextPage === Number(pagination?.page)) return;
    const target = findListStart(containerRef.current);
    filterDataHandler({ page: nextPage });
    // Wait for loading placeholders to render before measuring the new layout.
    scheduleContentScroll(target);
  };

  const customPage = (e) => {
    e.preventDefault();
    if (Number.isInteger(Number(page)) && Number(page) <= pagination.totalPages && Number(page) > 0) {
      changePage(Number(page));
    } else {
      warningMessage("صفحه وارد شده صحیح نمیباشد.");
    }
  };

  useEffect(() => {
    if (pagination) {
      setPage(pagination?.page);
    }
  }, [pagination]);

  const inputRef = useRef();

  return (
    <>
      {pagination?.totalPages > 1 ? (
        <div ref={containerRef} className="flex flex-wrap gap-3 items-center justify-between my-2 mt-4">
          <nav
            className="flex flex-wrap sm:flex-nowrap justify-center items-center gap-x-1"
            aria-label="Pagination"
          >
            <button
              onClick={() => changePage(Number(pagination?.page) - 1)}
              type="button"
              className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-xs md:text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
              disabled={pagination?.hasPrevPage ? false : true}
            >
              <svg
                className="shrink-0 size-3.5"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m9 18 6-6-6-6"></path>
              </svg>
              <span>صفحه قبل</span>
            </button>
            <div className="flex items-center gap-x-1">
              {pagination?.page - 1 > 0 ? (
                <button
                  onClick={() => changePage(1)}
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  1
                </button>
              ) : null}

              {pagination?.page - 2 > 0 ? (
                <button
                  onClick={() =>
                    changePage(Number(pagination?.page) - 2)
                  }
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  ...
                </button>
              ) : null}

              {pagination?.prevPage && pagination.page !== 2 ? (
                <button
                  onClick={() =>
                    changePage(Number(pagination?.page) - 1)
                  }
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  {pagination?.prevPage}
                </button>
              ) : null}

              <button
                type="button"
                className="min-h-[38px] min-w-[38px] flex justify-center items-center bg-gray-200 text-gray-800 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-300 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-600 dark:text-white dark:focus:bg-neutral-500"
                aria-current="page"
              >
                {pagination?.page}
              </button>

              {pagination?.nextPage ? (
                <button
                  onClick={() =>
                    changePage(Number(pagination?.page) + 1)
                  }
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  {pagination?.nextPage}
                </button>
              ) : null}

              {pagination?.totalPages - 2 > pagination?.page ? (
                <button
                  onClick={() =>
                    changePage(Number(pagination?.page) + 2)
                  }
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  ...
                </button>
              ) : null}

              {pagination?.totalPages - pagination?.page > 1 ? (
                <button
                  onClick={() =>
                    changePage(Number(pagination?.totalPages))
                  }
                  type="button"
                  className="min-h-[38px] min-w-[38px] flex justify-center items-center text-gray-800 hover:bg-gray-100 py-2 px-3 text-xs md:text-sm rounded-lg focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
                >
                  {pagination?.totalPages}
                </button>
              ) : null}
            </div>
            <button
              type="button"
              onClick={() => changePage(Number(pagination?.page) + 1)}
              className="min-h-[38px] min-w-[38px] py-2 px-2.5 inline-flex justify-center items-center gap-x-1.5 text-xs md:text-sm rounded-lg text-gray-800 hover:bg-gray-100 focus:outline-none focus:bg-gray-100 disabled:opacity-50 disabled:pointer-events-none dark:text-white dark:hover:bg-white/10 dark:focus:bg-white/10"
              aria-label="Next"
              disabled={pagination?.hasNextPage ? false : true}
            >
              <span>صفحه بعد</span>
              <svg
                className="shrink-0 size-3.5"
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="m15 18-6-6 6-6"></path>
              </svg>
            </button>
          </nav>
          <form
            onSubmit={customPage}
            className="flex justify-center sm:justify-start items-center gap-x-2"
          >
            <span className="text-xs md:text-sm text-gray-800 whitespace-nowrap dark:text-white">
              صفحه
            </span>
            <input
              min={1}
              ref={inputRef}
              onFocus={() => inputRef.current.select()}
              value={page}
              onChange={(e) => setPage(e.target.value)}
              className="h-8 w-10 py-2 px-2.5 block rounded-lg text-xs md:text-sm text-center disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 border border-[2px] border-gray-600  focus:border-blue-500 "
            />
          </form>
        </div>
      ) : null}
    </>
  );
};

export default Pagination;
